import * as types from "../constants";

const initialState = {
  isLoading: true,
  error: null,
  data: {},
};

export default function AcceptGtcReducer(state = initialState, action) {
  switch (action.type) {
    case types.ACCEPT_GTC_INIT:
      return { ...state, error: null, isLoading: true };

    case types.ACCEPT_GTC_SUCCESS:
      
      return { ...state, isLoading: false, data: action.data.data };

    case types.ACCEPT_GTC_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.notification.system_message,
      };

    default:
      return state;
  }
}
